import { Phone } from "lucide-react";

const StickyCallButton = () => (
  <a
    href="tel:1800556654"
    className="fixed bottom-4 right-4 z-50 md:hidden bg-green text-accent-foreground p-4 rounded-full shadow-lg hover:opacity-90 transition-opacity"
    aria-label="Call Now"
  >
    <Phone className="w-6 h-6" />
  </a>
);

export default StickyCallButton;
